import React from "react";
import { Outlet } from "react-router-dom";
import Navbar from "../components/Navbar/Navbar"
import Footer from "../components/Footer/Footer"
import WhatsAppTop from "../components/WhatsApp/WhatsAppTop";
const PublicLayout = () => {
  return (
    <div className="PublicLayout">
      <Navbar />
      <Outlet />
      <Footer />
      <WhatsAppTop />
    </div>
  );
};

export default PublicLayout;
